// extracted by mini-css-extract-plugin
module.exports = {"button":"_3welwPk","desktop":"_3G4lxkw","single":"_38nNOKh","sm":"_1Wn_7TB","multi":"_2CLwoGG"};